module.exports = __webpack_public_path__ + "static/media/GalleryImage03.177f17ec.jpg";